import React from 'react'

export const About = () => {
    return (
        <div className='about'>
            <div className='about-box'>
                <h1 className="about-title">о себе</h1>
                <p>Я владею HTML и CSS, самостоятельно разрабатываю проекты на <b>JavaScript</b> и <b>React</b>. Постоянно расширяю свои знания, изучаю современные технологии, в частности TypeScript, слежу за трендами через профильные ресурсы — Habr, Telegram-каналы и другие.</p>
                <p>Моя страсть — создавать интуитивно понятные, адаптивные интерфейсы с вниманием к мельчайшим деталям, чтобы каждый пользовательский опыт был максимально комфортным. Мне нравится писать код и искать нестандартные решения, которые помогают улучшить взаимодействие с приложениями.</p>
                <p>В работе активно использую нейросети ChatGPT, Midjourney и другие — для ускорения поиска информации, оптимизации рутинных задач и повышения своей продуктивности. </p>
                <p> Помимо frontend-разработки, поддерживаю активный образ жизни — баскетбол <img src="/portfolio/img/basketball.png" alt="Баскетбольный мяч" /> и лонгбординг <img src="/portfolio/img/longboard.png" alt="Лонгборд" /> вдохновляют меня так же, как и создание продуманных веб-приложений.</p>
            </div>
        </div>
    )
}
